export default {
    state: {
        isOpen: false,
    },
    mutations: {
        toggle(state,common) {
            state.isOpen = common
        },
    },
    actions: {
        TOGGLE_SIDE_MENU({commit}, data) {
            commit('toggle', data)
        },
    },
    getters: {
        isOpen: state => state.isOpen,
    }
}